/**
 * useFooter — fetches footer data from CMS with caching and error handling.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchFooterData } from '../api/footer';
import type { FooterData } from '../types/footer';

export function useFooter() {
  return useQuery<FooterData>({
    queryKey: ['footer'],
    queryFn: fetchFooterData,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    refetchOnWindowFocus: false,
    retry: 2,
  });
}
